import { render, staticRenderFns } from "./ModalStudyDetail.vue?vue&type=template&id=38184178&scoped=true"
import script from "./ModalStudyDetail.vue?vue&type=script&lang=js"
export * from "./ModalStudyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38184178",
  null
  
)

export default component.exports